import React from "react";
import dayjs from "dayjs";

const STATUS_STYLE = {
  APPROVED:  "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  PENDING:   "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  REJECTED:  "text-red-400 bg-red-500/10 border-red-500/20",
  CANCELLED: "text-white/30 bg-white/5 border-white/10",
};

const fmt = d => d ? dayjs(d).format("DD MMM") : "—";
const dur = (s, e) => { if (!s || !e) return "—"; return Math.max(1, dayjs(e).diff(dayjs(s), "day") + 1) + "d"; };

export default function LeaveTeamGrid({ loading, rows, onRowClick, onApprove, onReject }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-12 rounded-lg bg-white/5 animate-pulse" />)}
      </div>
    );
  }

  if (!rows?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No leave records for this period.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/5">
            {["Member","Type","From","To","Duration","Balance","Conflicts","Status",""].map(h => (
              <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
              <td className="px-3 py-3">
                <button onClick={() => onRowClick?.(r)} className="text-left hover:text-[#00ff90] transition-colors">
                  <p className="text-white font-medium">{r.name}</p>
                  <p className="text-white/30 text-xs">{r.role}</p>
                </button>
              </td>
              <td className="px-3 py-3 text-white/60 capitalize text-xs">{r.type}</td>
              <td className="px-3 py-3 text-white/50 text-xs">{fmt(r.from)}</td>
              <td className="px-3 py-3 text-white/50 text-xs">{fmt(r.to)}</td>
              <td className="px-3 py-3 text-white/40 text-xs">{r.days ? `${r.days}d` : dur(r.from, r.to)}</td>
              <td className="px-3 py-3 text-white/40 text-xs">{r.balanceLeft ?? "—"}</td>
              <td className="px-3 py-3">
                {r.conflicts > 0
                  ? <span className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 px-2 py-0.5 rounded-full">{r.conflicts} conflict{r.conflicts !== 1 ? "s" : ""}</span>
                  : <span className="text-white/15 text-xs">—</span>
                }
              </td>
              <td className="px-3 py-3">
                <span className={`text-xs px-2 py-0.5 rounded-full border capitalize ${STATUS_STYLE[r.status] || "text-white/30 bg-white/5 border-white/10"}`}>
                  {r.status?.toLowerCase()}
                </span>
              </td>
              <td className="px-3 py-3">
                {r.status === "PENDING" ? (
                  <div className="flex gap-2">
                    <button onClick={() => onApprove?.(r.id)}
                      className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                      Approve
                    </button>
                    <button onClick={() => onReject?.(r.id)}
                      className="text-xs px-3 py-1.5 rounded-lg border border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400 transition-colors">
                      Reject
                    </button>
                  </div>
                ) : <span className="text-white/15 text-xs">—</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}